import Icon from '@ant-design/icons';
import classNames from 'classnames';
import PubSub from 'pubsub-js';
import { useContext, useEffect } from 'react';

import RightSvg from '@/components/Icon/svgs/right.svg';
import { CONTAINER_EVENT } from '@/components/chat-app/utils/utils';
import HomeContext from '@/context/HomeContext';
import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import { useModel } from '@/hooks/useModel';
import useStorage from '@/hooks/useStorage';
import { EVENT } from '@/utils/event';

import styles from './index.less';

interface IProps {
  className?: string;
  iconClassName?: string;
}

function BackIcon(props: IProps) {
  const { className, iconClassName } = props;
  const { isLogin } = useModel('auth-model', (model) => ({ isLogin: model.isLogin }));
  const { setContext } = useContext(HomeContext);

  const [layoutSize] = useStorage('layoutSize');

  const handleStartNewChat = () => {
    if (!isLogin) {
      dispatchEvent(new CustomEvent(CONTAINER_EVENT.NEED_LOGIN));
    } else {
      if (layoutSize === LAYOUT_SIZE.SMALL) {
        dispatchEvent(new Event(EVENT.HIDE_MODAL_CHAT));
      }

      dispatchEvent(new Event(CONTAINER_EVENT.ONBOARD));
      dispatchEvent(new Event(CONTAINER_EVENT.CLOSE_SESSION));

      dispatchEvent(new Event(EVENT.CLOSE_TASK_LIST));
      dispatchEvent(new CustomEvent(CONTAINER_EVENT.CHAT_INPUT_FOCUS));
      // 用于更新chat标题
      PubSub.publish(EVENT.NEW_CHAT_CALLBACK);

      setContext({ chatHomepageRoute: undefined, chatCircleRoute: undefined });
    }
  };

  useEffect(() => {
    addEventListener(EVENT.CLICK_NEW_CHAT_BUTTON, handleStartNewChat);

    return () => {
      removeEventListener(EVENT.CLICK_NEW_CHAT_BUTTON, handleStartNewChat);
    };
  }, []);

  return (
    <div className={classNames(styles.buttonItem, className)} onClick={() => handleStartNewChat()}>
      <Icon className={classNames(styles.icon, iconClassName)} component={RightSvg} rotate={180} />
    </div>
  );
}

export default BackIcon;
